import styled from 'styled-components'
import './SBDK.scss'
import moment from 'moment'
import { FooterSection, LeadingTitle } from '@components'
import { useState, useEffect } from 'react'
import { SBDKAPI, ShortDescriptionAPI } from '@api'
import { useTranslation } from 'react-i18next'
import env from '../../common/variables/EndpointEnvironment.js'

moment.locale('id')

const InvestorContainer = styled.div`
  background-color: #f9f9f9;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const SBDK = function () {
  const { t } = useTranslation()
  const [SBDK, setSBDK] = useState(null)
  const [shortDesc, setShortDesc] = useState(null)

  useEffect(() => {
    const loadSBDK = async () => {
      const { data } = await SBDKAPI()
      setSBDK({
        ...data.data[0],
        ...{
          description:
            data.data[0].description &&
            data.data[0].description
              .split('href="/')
              .join(`href="${env.HOST_PIMCORE}`),
        },
      })
    }

    const loadData = async () => {
      const { data } = await ShortDescriptionAPI({ loc: 'sbdk' })
      setShortDesc(data.data)
    }

    if (!shortDesc) {
      loadData()
    }

    if (SBDK === null) {
      loadSBDK()
    }
  }, [SBDK, shortDesc])
  return (
    <InvestorContainer>
      <LeadingTitle
        title={SBDK !== null ? SBDK.title : t('sbdk')}
        subtitle={shortDesc !== null ? shortDesc.description : ''}
      />
      <div className="sbdk-content">
        <p className="label-date">
          {SBDK !== null
            ? moment(SBDK.created_at, 'DD-MM-YYYY hh:mm:ss').format(
                'DD MMMM YYYY'
              )
            : 'null'}
        </p>
        <h3 className="label-title">{t('suku_bunga_dasar_kredit')}</h3>
        <h5 className="label-company">PT BANK KB INDONESIA Tbk</h5>

        <div className="segment-box">
          <div className="segment-box-title">
            <p>{t('berdasarkan_segmen_kredit')}</p>
            <p>( % {t('per_tahun')} )</p>
          </div>
          <div className="segment-content-top">
            <div className="segment-content-item">
              <p className="title">{t('corporate_credit')}</p>
              <h5 className="desc">
                {SBDK != null ? SBDK.kredit_korporasi : '0'}%
              </h5>
            </div>
            <div className="segment-content-item">
              <p className="title">{t('retail_credit')}</p>
              <h5 className="desc">
                {SBDK != null ? SBDK.kredit_ritel : '0'}%
              </h5>
            </div>
            <div className="segment-content-item">
              <p className="title">{t('micro_credit')}</p>
              <h5 className="desc">
                {SBDK != null ? SBDK.kredit_mikro : '0'}%
              </h5>
            </div>
          </div>
          <div className="segment-content-bottom">
            <p className="title dekstop-version">{t('consumption_credit')}</p>
            <div className="segment-content-bottom-box">
              <div className="segment-content-item-left">
                <p className="title">
                  <span className="mobile-version">
                    {t('consumption_credit')}
                  </span>{' '}
                  KPR
                </p>
                <h5 className="desc">
                  {SBDK != null ? SBDK.kredit_konsumsi_KPR : '0'}%
                </h5>
              </div>
              <div className="segment-content-item-right">
                <p className="title">Non KPR</p>
                <h5 className="desc">{SBDK != null ? SBDK.non_KPR : '0'}%</h5>
              </div>
            </div>
          </div>
          <div className="segment-content-bottom mobile-version">
            <div className="segment-content-bottom-box">
              <div className="segment-content-item-left">
                <p className="title">Non KPR</p>
                <h5 className="desc">{SBDK != null ? SBDK.non_KPR : '0'}%</h5>
              </div>
            </div>
          </div>
        </div>

        <div className="description-box">
          <h4 className="label-desc">{t('keterangan')}</h4>
          <div
            dangerouslySetInnerHTML={{
              __html: SBDK != null ? SBDK.description : '',
            }}
          ></div>
          {/* <ol>
            <li>              
              Pengumuman ini disampaikan dalam rangka memenuhi Surat Edaran
              Otoritas Jasa Keuangan Nomor 34/SEOJK.03/2017 tanggal 7 Juli 2017.
            </li>
            <li>
              Suku Bunga Dasar Kredit (SBDK) digunakan sebagai dasar penetapan
              suku bunga kedit yang akan dikenakan oleh Bank kepada nasabah.
              SBDK ini belum memperhitungkan komponen estimasi premi risiko yang
              besarnya tergantung dari penilaian Bank Bukopin terhadap risiko
              masing-masing debitur atau kelompok debitur. Dengan demikian,
              besarnya suku bunga kredit yang dikenakan kepada debitur belum
              tentu sama dengan Suku Bunga Dasar Kredit.
            </li>
            <li>
              Dalam Kredit Konsumsi non KPR tidak termasuk penyediaan dana
              melalui kartu kredit dan kredit tanpa agunan.
            </li>
            <li>
              Informasi Suku Bunga Dasar Kredit (SBDK) yang berlaku setiap saat
              dapat dilihat pada publikasi di setiap kantor Bank dan atau situs
              web Bank (https://www.bukopin.co.id).
            </li>
            <li>
              Suku Bunga Dasar Kredit (SBDK) ini mulai berlaku efektif sejak
              hari Senin, 5 April 2021 dan dapat berubah sewaktu-waktu
              berdasarkan pengumuman dari Bank.
            </li>
          </ol> */}
        </div>
      </div>
      <FooterSection currentPage={t('sbdk')} />
    </InvestorContainer>
  )
}

export default SBDK
